// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// 原本的lib-flexible对于大于540的屏幕做了限制
// libsV2里的lib-flexible，是复制了lib-flexible/flexible.js，并对refreshRem方法就行了修改，去除了540的限制
// import 'lib-flexible/flexible.js'
import '@/libsV2/lib-flexible.js'
import Vue from 'vue'
import Vuex from 'vuex';
import App from './App'
import router from './router'
import store from './store/store'
import userstore from './store/member/index/housestore.js';
import defalutData from "@/libsV2/defaultData";
import '@/utils/slsTracker'

// +----------------------------------------------------------------------
// | 兼容类
// +----------------------------------------------------------------------
// ios间距处理
import './libs/ios-font';

// 设置vue忽略该跳转小程序的组件，避免出现错误
Vue.config.ignoredElements = defalutData.ignoredElements;
// +----------------------------------------------------------------------
// | 底层（核心）类
// +----------------------------------------------------------------------
import cookie from './libsV2/cookie.js';
import storage from './libsV2/storage';
import common from './libsV2/common';
import oInitData from './libsV2/request';
import urlApi from './libsV2/urlApi';

Vue.prototype.$common = common;
Vue.prototype.$oInitData = oInitData;
Vue.prototype.$storage = storage;
Vue.prototype.$config = urlApi;
Vue.prototype.$userHouse = userstore;

// +----------------------------------------------------------------------
// | 组件类
// |
// +----------------------------------------------------------------------
/*引入资源请求插件*/
import VueLazyload from 'vue-lazyload';
import VueResource from 'vue-resource';
import VueWechatTitle from 'vue-wechat-title';

import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VuePreview from 'vue-preview';
import preview from 'vue-photo-preview'
import AwesomePicker from 'vue-awesome-picker';
import VDistpicker from 'v-distpicker';
import AMap from 'vue-amap';
import LyTab from "ly-tab";
import 'vue-photo-preview/dist/skin.css';
import 'swiper/swiper-bundle.css';

Vue.use(VueLazyload, defalutData.vueLazyLoadOption)
Vue.use(AMap);

// 高德地图api初始化
AMap.initAMapApiLoader({
    key: defalutData.AMapData.key,
    plugin: defalutData.AMapData.plugin,
});
window._AMapSecurityConfig = { // 密钥
    securityJsCode: defalutData.AMapData.securityJsCode,
};
Vue.use(preview, defalutData.previewData)
Vue.use(VuePreview);
Vue.use(VueAwesomeSwiper);
Vue.use(AwesomePicker);
Vue.use(LyTab);
Vue.use(VueResource);
Vue.use(VueWechatTitle);
Vue.component('v-distpicker', VDistpicker);

// +----------------------------------------------------------------------
// | 框架类  vant  echarts  mint-ui
// +----------------------------------------------------------------------
import {
    Overlay,
    Toast,
    Uploader,
    Button,
    Slider,
    ImagePreview,
    Picker,
    Popup,
    Field,
    Swipe,
    SwipeItem,
    Area,
    DatetimePicker,
    Dialog,
    Search,
    Cell,
    CheckboxGroup,
    CellGroup,
    Checkbox,
    Calendar,
    Cascader,
    List,
    PullRefresh,
    Icon,
    NoticeBar,
    Rate,
    Tab,
    Tabs,
    Pagination as PaginationVant,
    DropdownMenu,
    DropdownItem
} from 'vant';
import '@vant/touch-emulator';
import Mint from 'mint-ui';

import echarts from '@/libsV2/echarts.js';

Vue.use(Mint);
Vue.use(PaginationVant);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(ImagePreview);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(CheckboxGroup);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Checkbox);
Vue.use(Button);
Vue.use(Uploader);
Vue.use(Field);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Area);
Vue.use(DatetimePicker);
Vue.use(Dialog);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Search);
Vue.use(Calendar);
Vue.use(NoticeBar);
Vue.use(Overlay);
Vue.use(Rate);
Vue.use(Cascader);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.prototype.$toast = Toast;
Vue.prototype.$echarts = echarts

import {Table, TableColumn} from 'element-ui'

Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);

// +----------------------------------------------------------------------
// | 对象类
// +----------------------------------------------------------------------

import clipboard from 'clipboard';

Vue.prototype.$clipboard = clipboard;

// +----------------------------------------------------------------------
// | 初始化方法
// +----------------------------------------------------------------------
/**
 * 全局init方法
 * @param callback 授权成功之后的回调函数
 */
window.$init = function (callback) {
    // 获得默认数据
    storage.getDefaultData();
    // 获取url后面参数 如果是reload 清除本地数据
    if (common.getQueryString('wscinit') == 'reload2') {
        storage.setStorage('session_id', '');
        storage.setStorage('token', '');
        storage.setStorage('homeMenu', '');
        cookie.deleteAllCookie(); // 删除所有cookie
    }
    // 获取token
    oInitData.getToken().then(res => {
        if (store.state.initError) {
            //   console.log("严重：init接口错误！");
            return false;
        }
        // 判断是不是微信端
        if (res.is_wechat == 0) {
            if (res.is_login) {
                if (callback) {
                    callback(res);
                }
                return true;
            } else {
                window.location.href = res.oauth_url
            }
        } else {

            // 判断用户登录
            if (res.is_login) {
                // 判断授权登录
                if (res.is_wx_auth) {
                    // 执行回调函数
                    if (callback) {
                        callback(res);
                    }
                } else {
                    // 判断没有没有这个字段 ： oauth_url
                    if (res.oauth_url) { // 如果有跳转到这个字段   oauth_url
                        storage.removeStorage('token');
                        window.location.href = res.oauth_url;
                    } else {
                        let inviteuid = oInitData.getQueryString('inviteuid');
                        // 刷新缓存。如果有inviteuid。带上inviteuid
                        Toast({
                            message: "授权系统繁忙！",
                            duration: 1200
                        });
                    }
                }
            } else {
                if (res.is_wx_auth || res.is_wx_rela) {

                    return true;
                }
                // 判断没有没有这个字段 ： oauth_url
                else if (res.oauth_url) { // 如果有跳转到这个字段   oauth_url
                    //  console.log('无信息');
                    localStorage.clear();
                    // return;
                    // cookie.deleteAllCookie();
                    window.location.href = res.oauth_url;
                    return;
                } else {
                    // 刷新缓存。如果有inviteuid。带上inviteuid
                    Toast({
                        message: "返回值缺少授权地址;main:157",
                        duration: 1200
                    });
                }
            }
        }
    });
};
// +----------------------------------------------------------------------

Vue.use(Vuex);
Vue.config.productionTip = false;
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
}).$mount("#app");
